import React, { useMemo } from 'react';

import styled from '@mint-lib/styled';

import { css } from '@myn/mui';

import { getPlatformIcon } from '../../../../../../utils/campaignsBuilder.js';
import type { BuilderTableRow } from '../../../../types.js';

type Props = {
  row: BuilderTableRow;
  scale: number;
  logo?: string | null;
};
const PlatformImage: React.FC<Props> = ({ row, scale, logo }) => {
  const src = useMemo(() => getPlatformIcon(row), [row]);
  const logoSrc = logo || src;

  return <Image src={logoSrc} alt={logoSrc} $scale={scale}></Image>;
};

export default PlatformImage;

const Image = styled('img')<{ $scale: number }>`
  width: 16px;
  height: 16px;
  ${({ $scale }) => css`
    width: ${16 * $scale}px;
    height: ${16 * $scale}px;
  `}
`;
